module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-7.19cba070.png";